// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'times';

export const Component = () => (
  <path
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M3 15 14 4M3 4l11 11'
  />
);

export const viewBox = '0 0 18 18';
